export default "__VITE_ASSET__BDFNg9A3__"